// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_authContainer__HiMwD {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 100px);
  justify-content: center;
  padding: 40px 20px;
}
.styles_authContainer__HiMwD.styles_showHeader__y\\+JtU {
  min-height: calc(100vh - 200px);
}

.styles_cardBox__-ggB1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  border-radius: 16px;
  gap: 0;
  background-color: var(--color-white);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
@media (min-width: 768px) {
  .styles_cardBox__-ggB1 {
    border-radius: 40px;
    padding: 40px;
  }
}

.styles_card__e3uFR {
  border: none;
  box-shadow: none;
  padding: 0;
  gap: 24px;
  width: 100%;
}

.styles_logoBox__OyiZj {
  display: none;
}

.styles_headerTitle__D94S6 {
  font: var(--typography-logo);
}

.styles_headerSubtitle__X3w6- {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
}

.styles_socialButtons__hP9pq {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (min-width: 768px) {
  .styles_socialButtons__hP9pq {
    flex-direction: row;
  }
}

.styles_main__xnRKt {
  gap: 32px;
}

.styles_formFieldLabel__3f-2U {
  font: var(--typography-body-m-regular);
}

.styles_formFieldInput__jQlF9 {
  width: 100%;
  padding: 10px 14px;
  font-size: 16px;
  border: 1px solid var(--color-gray-strokes);
  border-radius: 12px;
  color: var(--color-black);
  background-color: var(--color-white);
  transition: all 0.2s ease;
  outline: none;
}
.styles_formFieldInput__jQlF9::placeholder {
  color: var(--color-text-secondary);
}
.styles_formFieldInput__jQlF9:hover, .styles_formFieldInput__jQlF9:focus {
  border-color: var(--color-blue-light) !important;
  box-shadow: 0 0 0 1px var(--color-blue-light) !important;
}
.styles_formFieldInput__jQlF9:disabled {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}
.styles_formFieldInput__jQlF9:disabled::placeholder {
  color: var(--color-text-secondary);
}
.styles_formFieldInput__jQlF9.styles_cl-internal-error__kWOHe {
  border-color: var(--color-error);
  box-shadow: 0 0 0 1px var(--color-error);
}
.styles_formFieldInput__jQlF9:hover:not(:disabled) {
  border-color: var(--color-blue-light);
}

.styles_formButtonPrimary__l7O1s {
  font: var(--typography-label);
  background-color: var(--color-black);
}

.styles_footer__I4Cox {
  width: 100%;
  background: var(--color-white);
}

.styles_footerAction__QS6Al {
  background: var(--color-white);
  font: var(--typography-body-s-regular);
}

.styles_form__5xWUN {
  gap: 24px;
}`, "",{"version":3,"sources":["webpack://./src/screens/waitlist/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;AAAF;AAEE;EACE,+BAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,oCAAA;EACA,yCAAA;AADF;ACdE;EDOF;IAWI,mBAAA;IACA,aAAA;EAAF;AACF;;AAGA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAGA;EACE,sCAAA;EACA,kCAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;AC/CE;ED4CF;IAMI,mBAAA;EACF;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,aAAA;AACF;AACE;EACE,kCAAA;AACJ;AAEE;EAEE,gDAAA;EACA,wDAAA;AADJ;AAIE;EACE,8CAAA;EACA,0CAAA;EACA,kCAAA;EACA,mBAAA;AAFJ;AAII;EACE,kCAAA;AAFN;AAME;EACE,gCAAA;EACA,wCAAA;AAJJ;AAOE;EACE,qCAAA;AALJ;;AASA;EACE,6BAAA;EACA,oCAAA;AANF;;AASA;EACE,WAAA;EACA,8BAAA;AANF;;AASA;EACE,8BAAA;EACA,sCAAA;AANF;;AASA;EACE,SAAA;AANF","sourcesContent":["@import \"mixins\";\n.authContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: calc(100vh - 100px);\n  justify-content: center;\n  padding: 40px 20px;\n\n  &.showHeader {\n    min-height: calc(100vh - 200px);\n  }\n}\n\n.cardBox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 16px;\n  border-radius: 16px;\n  gap: 0;\n  background-color: var(--color-white);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n\n  @include md {\n    border-radius: 40px;\n    padding: 40px;\n  }\n}\n\n.card {\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  gap: 24px;\n  width: 100%;\n}\n\n.logoBox {\n  display: none;\n}\n\n.headerTitle {\n  font: var(--typography-logo);\n}\n\n.headerSubtitle {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n}\n\n.socialButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  @include md {\n    flex-direction: row;\n  }\n}\n\n.main {\n  gap: 32px;\n}\n\n.formFieldLabel {\n  font: var(--typography-body-m-regular);\n}\n\n.formFieldInput {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  color: var(--color-black);\n  background-color: var(--color-white);\n  transition: all 0.2s ease;\n  outline: none;\n\n  &::placeholder {\n    color: var(--color-text-secondary);\n  }\n\n  &:hover,\n  &:focus {\n    border-color: var(--color-blue-light) !important;\n    box-shadow: 0 0 0 1px var(--color-blue-light) !important;\n  }\n\n  &:disabled {\n    background-color: var(--color-button-disabled);\n    border-color: var(--color-button-disabled);\n    color: var(--color-text-secondary);\n    cursor: not-allowed;\n\n    &::placeholder {\n      color: var(--color-text-secondary);\n    }\n  }\n\n  &.cl-internal-error {\n    border-color: var(--color-error);\n    box-shadow: 0 0 0 1px var(--color-error);\n  }\n\n  &:hover:not(:disabled) {\n    border-color: var(--color-blue-light);\n  }\n}\n\n.formButtonPrimary {\n  font: var(--typography-label);\n  background-color: var(--color-black);\n}\n\n.footer {\n  width: 100%;\n  background: var(--color-white);\n}\n\n.footerAction {\n  background: var(--color-white);\n  font: var(--typography-body-s-regular);\n}\n\n.form {\n  gap: 24px;\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authContainer": `styles_authContainer__HiMwD`,
	"showHeader": `styles_showHeader__y+JtU`,
	"cardBox": `styles_cardBox__-ggB1`,
	"card": `styles_card__e3uFR`,
	"logoBox": `styles_logoBox__OyiZj`,
	"headerTitle": `styles_headerTitle__D94S6`,
	"headerSubtitle": `styles_headerSubtitle__X3w6-`,
	"socialButtons": `styles_socialButtons__hP9pq`,
	"main": `styles_main__xnRKt`,
	"formFieldLabel": `styles_formFieldLabel__3f-2U`,
	"formFieldInput": `styles_formFieldInput__jQlF9`,
	"cl-internal-error": `styles_cl-internal-error__kWOHe`,
	"formButtonPrimary": `styles_formButtonPrimary__l7O1s`,
	"footer": `styles_footer__I4Cox`,
	"footerAction": `styles_footerAction__QS6Al`,
	"form": `styles_form__5xWUN`
};
export default ___CSS_LOADER_EXPORT___;
